import {getIsServer} from './getIsServer';

export const getHeaders = async () => {
    if (!getIsServer()) {
        throw Error('not implemented');
    }
    return require('next/headers').headers() as Headers;
};
